import { render, staticRenderFns } from "./SupplyChainItemQuotaReportTab.vue?vue&type=template&id=720dac53"
import script from "./SupplyChainItemQuotaReportTab.vue?vue&type=script&lang=js"
export * from "./SupplyChainItemQuotaReportTab.vue?vue&type=script&lang=js"
import style0 from "./SupplyChainItemQuotaReportTab.vue?vue&type=style&index=0&id=720dac53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports